export const extractUrlHost = (url: string) => {
  try {
    return new URL(url).host;
  } catch {
    return 'unknown';
  }
};

/**
 * Builds a URL string from a list of parts. Accounts for leading and trailing slashes.
 *
 * @param parts - The parts of the URL to build.
 * @returns The built URL string.
 * @example
 * ```ts
 * buildUrlString('https://api.example.com/', '/rpc/v2/createSession')
 * // Returns: 'https://api.example.com/rpc/v2/createSession'
 * ```
 */
export const buildUrlString = (...parts: string[]) => {
  return parts.map((part) => part.replace(/^\/|\/$/g, '')).join('/');
};

export const truncateString = (str: string, maxLength: number) => {
  return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
};

export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
